/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
//import Meta from 'vue-meta'

// Routes
import paths from './paths'

function route (pathObj, view, name) {
  return {
    name: pathObj.name || pathObj.view,
    path: pathObj.path,
    meta: pathObj.meta,
    component: r => pathObj.component.then(r)
    // component: (resovle) => import(
    //   `@/views/${pathObj.view}.vue`
    // ).then(resovle)
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  //mode: 'history',
  routes: paths.map(path => route(path)).concat([
    { path: '*', redirect: '/dashboard' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

//Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}

export default router
//ALEXMODI
